import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * assetActionCreators
 */
import * as ajax from './ajax';
import changeActionFactory from './factories/changeActionFactory';
import { constantsRegistry } from '../constants/tableConstantsFactory';
import detailActionFactory from './factories/detailActionFactory';
import entityActionFactory from './factories/entityActionFactory';
import tokenErrorActions from './tokenErrorActionCreators';
import uploadActionFactory from './factories/uploadActionFactory';
const detailActions = detailActionFactory('asset', 'assets');
const entityActions = entityActionFactory('asset', 'assets');
const changeActions = changeActionFactory('asset', 'assets');
const uploadActions = uploadActionFactory('asset', 'assets', false, 'Photo');
const constants = constantsRegistry('asset');
const duplicateFail = (ids, error) => ({
  type: constants.DUPLICATE_FAIL,
  ids,
  error
});
const duplicateSuccess = data => ({
  type: constants.DUPLICATE_SUCCESS,
  data
});

/*
 * Saves an array of records to the server to be duplicated.
 */
const duplicate = ids => async dispatch => {
  try {
    const response = await ajax.post('/assets/duplicate', ids);
    return dispatch(duplicateSuccess(response.data));
  } catch (e) {
    return dispatch(tokenErrorActions.handleError(e, 'asset', duplicateFail.bind(this, ids, e), duplicate.bind(this, ids)));
  }
};
export default _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeActions), entityActions), detailActions), uploadActions), {}, {
  duplicate
});